export default "__VITE_ASSET__ddeb811e__"